import { useLayoutEffect, useRef, useState } from 'react';
import { ChessPuzzle } from '@react-chess-puzzle-fix/react-chess-puzzle';

export default function PuzzleBoard({ boardSize = 600 }) {
  const containerRef = useRef(null);
  const [availableWidth, setAvailableWidth] = useState(0);

  useLayoutEffect(() => {
    const container = containerRef.current;
    const measure = () => setAvailableWidth(Math.floor(container.getBoundingClientRect().width));
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(container);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef} data-testid="shared-puzzle-board" className="mx-auto flex w-full max-w-[700px] justify-center">
      {availableWidth > 0 && (
        <div className="w-fit shrink-0">
          <ChessPuzzle.Board boardWidth={Math.min(boardSize, availableWidth)} />
        </div>
      )}
    </div>
  );
}
